var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('please-wait',{staticClass:"mt-5"}):_c('PinturaEditor',_vm._b({ref:"editor",style:(_vm.editerStyle),on:{"pintura:process":function($event){return _vm.handleProcess($event)}}},'PinturaEditor',_vm.editorProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }